import React, { FC, useEffect, useState } from 'react';
import { useFormik } from 'formik';
import { ApplicationViewContactInfo } from './ApplicationViewContactInfo';
import { ApplicationOwner } from '../application/ApplicationOwner';
import { ApplicationViewCompanyInfo } from './ApplicationViewCompanyInfo';
import { IOwners } from '../../interfaces/merchant';
import { ApplicationViewAgreement } from './ApplicationViewAgreement';
import { ApplicationViewSummaryFooter } from './ApplicationViewSummaryFooter';
import { ApplicationViewHeaderInformation } from './ApplicationViewHeaderInformation';
import { VolumeEstimates } from '../application/VolumeEstimates';
import { BusinessModel } from '../application/BusinessModel';
import { ProductInformation } from '../application/ProductInformation';
import {
  FORM_FIELDS,
  getInitialValues,
} from '../../constants/new-application/new-application-form';
import { useTranslation } from 'react-i18next';
import { fetchApplicationView } from '../../store/merchnts/actions/application-view';
import { IAuthState } from '../../redux/AuthRedux';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../setup';
import { parseJwt, STATUSES } from '../../views/login/Login';
import { useMerchants } from '../../store/merchnts/merchants-context';
import { Spinner } from '../Spinner';
import SpecialTermsCard from '../application/SpecialTermsCard';
import { fetchStatus } from '../../store/merchnts/actions/confirm-application';
import { ApplicationViewFees } from './ApplicationViewFees';
import { getBusinessDetailsValidationSchema } from '../../constants/application-view/application-view-form';
import { APPLICATION_VIEW_BASE_VIEW, APPLICATION_VIEW_STEPS } from './ApplicationViewAsideMenu';
import { useNavigate } from 'react-router-dom';
import { DocumentsUploaderPage } from '../application/quick-application/DocumentsUploaderPage';
import { GET } from '../../store/store-helper';
import { BASE_URL } from '../../../config/environmentConfig';
import * as auth from '../../redux/AuthRedux';
import { logout } from '../../redux/AuthCRUD';
import { setApplicationDocuments } from '../../store/merchnts/actions/application';
import AddressCard from '../application/AddressCard';
import BankInformationCard from '../application/BankInformationCard';

export const ApplicationViewSummary: FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const authUser: IAuthState = useSelector<RootState>(({ auth }) => auth, shallowEqual);
  const user = parseJwt(authUser.idToken);
  const mid = user?.['custom:mid'];

  const { merchantState: { isApplicationViewDataLoading, applicationViewData }, dispatch: merchantDispatch } = useMerchants();

  const [checkBoxes, setCheckBoxes] = useState<string[]>([]);
  const [ownerData, setOwnerData] = useState<IOwners[]>([]);

  const formik = useFormik({
    initialValues: getInitialValues({ partnerId: '', integrationPartnerId: '' }),
    validationSchema: getBusinessDetailsValidationSchema(t),
    onSubmit: () => void 0
  });
  const handleError = async (): Promise<void> => {
    const data = await GET({
      pathname: `${BASE_URL.MERCHANTS}/onboarding/${mid}/status`
    });

    if (data?.statusName !== STATUSES.APPROVED) {
      try {
        await logout(authUser?.accessToken);
        console.log('logout---007');
        dispatch(auth.actions.logout());
        navigate('/');
      } catch (e) {
        console.log('e', e);
      }
    }
  };

  useEffect(() => {
    void fetchApplicationView({ dispatch: merchantDispatch, mid, formik, onError: handleError });
    void fetchStatus(merchantDispatch, mid);
  }, []);

  useEffect(() => {
    console.log('applicationViewData', applicationViewData);
    if (applicationViewData?.statusName === STATUSES.DRAFT) {
      navigate(`/${APPLICATION_VIEW_BASE_VIEW}/${APPLICATION_VIEW_STEPS.BUSINESS_DETAILS}`);
    }

    if (applicationViewData?.owners?.length > 0) {
      setOwnerData(applicationViewData.owners);
    }
  }, [applicationViewData]);

  if (isApplicationViewDataLoading) {
    return (
      <div className="card h-100">
        <div className="card-body">
          <Spinner pageLoader/>
        </div>
      </div>
    );
  }

  return(
    <>
      <ApplicationViewHeaderInformation />
      <form onSubmit={formik.handleSubmit}>
        <ApplicationViewCompanyInfo formik={formik} formEditStatus={false}/>
        <VolumeEstimates formik={formik} formEditStatus={false} isRequired={true} />

        <DocumentsUploaderPage
            showPlaceholder={false}
            id={applicationViewData?.id}
            setDocuments={setApplicationDocuments}
            dataUploadedDocuments={applicationViewData?.uploadedDocuments}
            enableEditBlock={applicationViewData?.statusName === STATUSES.SUBMITTED}
            onEditSuccess={async (): Promise<void> => await fetchApplicationView({ dispatch: merchantDispatch, mid, formik })}
        />

        <BusinessModel
            formik={formik}
            formEditStatus={false}
            isRequired={false}
            urls={applicationViewData?.businessModel?.urls}
        />

        <ApplicationViewContactInfo formik={formik} formEditStatus={false} isRequired={true} />

        <ApplicationOwner
          appOwnerData={ownerData}
          setAppOwnerData={setOwnerData}
          formEditStatus={false}
          showActions={false}
          showAddButton={false}
        />

        {/*<ProductInformation*/}
        {/*  formik={formik}*/}
        {/*  formEditStatus={false}*/}
        {/*  data={applicationViewData?.productInfo?.trafficAcquisition}*/}
        {/*  setCheckBoxes={setCheckBoxes}*/}
        {/*  isRequired={true}*/}
        {/*/>*/}

        <AddressCard formik={formik} formEditStatus={false}/>

        <BankInformationCard
            formEditStatus={false}
            formik={formik}
        />


        {
            !applicationViewData.contractAlreadySigned && (<ApplicationViewFees />)
        }
        {
          !applicationViewData.contractAlreadySigned && (
                <SpecialTermsCard
                    formik={formik}
                    formEditStatus={false}
                    fieldName={FORM_FIELDS.SPECIAL_TERMS}
                    // label={t(FORM_FIELDS.SPECIAL_TERMS)}
                />
            )
        }

        {
          applicationViewData?.statusName !== STATUSES.SUBMITTED && (
            <>
              {
                !applicationViewData.contractAlreadySigned && (
                      <ApplicationViewAgreement />
                  )
              }

              <ApplicationViewSummaryFooter formik={formik} />
            </>
          )
        }
      </form>
    </>
  );
};
